import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ProjectsItem.css';

export default function ProjectsItem({projectItem, user, services, isMobile}) {
    const maxURLLength = 25

    const handleDropdownClick = (evt) => {
        evt.stopPropagation()
    }
  return (
    <tr className='ProjectsItem'>
        <td className='projNum'>
            {projectItem.projNum? projectItem.projNum:'---'}
        </td>
        <td className='projType'>
            {projectItem.projType? capitalizeFirstLetter(projectItem.projType):'---'}
        </td>
        <td className='projTitle'>
            {projectItem.projTitle? capitalizeFirstLetter(projectItem.projTitle) : 
            services.find((service) =>service.code===projectItem.projType) ?`${services.find((service) =>service.code===projectItem.projType).name} for ${capitalizeFirstLetter(projectItem.clientName)}`: 
            `${projectItem.projType} for ${capitalizeFirstLetter(projectItem.clientName)}`}
        </td>
        <td className='clientDeadline'>
            <div>
                { projectItem.clientDeadline ?
                new Date(projectItem.clientDeadline).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                : 
                '---'
                }
            </div>
        </td>
        <td className='projectStatus status'>
            <div className={`statusContainer ${projectItem.projectStatus}`}>
                <div className={`statusColor ${projectItem.projectStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.projectStatus === 'unassigned' ? 'Unassigned' : projectItem.projectStatus === 'inProgress' ? 'In Progress' : projectItem.projectStatus === 'inReview' ? 'In Review' : projectItem.projectStatus === 'completed' ? 'Completed' : 'Cancelled'}
                    </strong>
                </div>
            </div>
        </td>
        <td className='projectReportURL linkChain'>
            {projectItem.projectReportURL? 
            <a href={projectItem.projectReportURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        <td className='otherURLs linkChain'>
            {(projectItem.otherURL1 || projectItem.otherURL2 || projectItem.otherURL3 || projectItem.otherURL4)?
            <div className='otherURLsContainer dropdown'>
                <div className='otherLinksDropDownToggle' data-title='otherLinks' id='otherLinksDropDownToggle' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                        <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                        <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                    </svg>
                </div>
                <div className='dropdown-menu otherLinksDropDown' aria-labelledby="otherLinksDropDownToggle" onClick={handleDropdownClick}>
                    { projectItem.otherURL1 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL1}`}>{`${projectItem.otherURL1.substring(0,maxURLLength)}${projectItem.otherURL1.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL2 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL2}`}>{`${projectItem.otherURL2.substring(0,maxURLLength)}${projectItem.otherURL2.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL3 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL3}`}>{`${projectItem.otherURL3.substring(0,maxURLLength)}${projectItem.otherURL3.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL4 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL4}`}>{`${projectItem.otherURL4.substring(0,maxURLLength)}${projectItem.otherURL4.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                </div>
            </div>
            :
            '---'
            }
        </td>
    </tr>
  )
}
